<template>
  <cs-preloader-overlay loading />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ReportDownload',
  created() {
    this.getReport();
  },
  methods: {
    async getReport() {
      try {
        const data = await this.fetchReport(this.$route.query);

        if (this.$validate.isObjectWithFields(data, ['url'])) {
          window.location.assign(data.url);
        }
      } catch {
        this.$alert({
          type: 'warning',
          text: this.$t('something.wrong'),
        });
      }

      this.$router.push({ name: 'cabinet' });
    },
    ...mapActions('reports', ['fetchReport']),
  },
};
</script>
